module.exports = __webpack_public_path__ + "static/media/penButton.49a42e72.png";